<script setup lang="ts">
import Hero from '@/components/Hero.vue'
import About from '@/components/About.vue'
import Services from '@/components/Services.vue'
import Approaches from '@/components/Approaches.vue'
import Practical from '@/components/Practical.vue'
import Booking from '@/components/Booking.vue'
import Contact from '@/components/Contact.vue'
import Footer from '@/components/Footer.vue'
import ThemeToggle from '@/components/ThemeToggle.vue'

const sections = [
  { id: 'about', label: 'À propos' },
  { id: 'services', label: 'Consulter' },
  { id: 'approches', label: 'Approches' },
  { id: 'modalites', label: 'Modalités' },
  { id: 'rendez-vous', label: 'Rendez-vous' },
  { id: 'contact', label: 'Contact' }
]
</script>

<template>
  <div class="min-h-screen bg-stone-50 dark:bg-stone-950 text-stone-900 dark:text-stone-100">
    <a href="#main"
      class="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:px-3 focus:py-2 focus:rounded-md focus:bg-stone-900 focus:text-stone-50">
      Aller au contenu principal
    </a>

    <!-- Ambient glow blobs -->
    <div class="fixed inset-0 pointer-events-none z-[5]" aria-hidden="true">
      <div class="absolute -top-20 -left-20 w-96 h-96 bg-terracotta-400/15 rounded-full blur-3xl" />
      <div class="absolute top-1/3 -right-20 w-80 h-80 bg-terracotta-300/15 rounded-full blur-3xl" />
      <div class="absolute bottom-0 left-1/3 w-72 h-72 bg-stone-400/10 rounded-full blur-3xl" />
    </div>

    <!-- Noise texture overlay -->
    <svg class="hidden" aria-hidden="true">
      <filter id="noise">
        <feTurbulence type="fractalNoise" baseFrequency="0.80" numOctaves="4" stitchTiles="stitch" />
      </filter>
    </svg>
    <div class="fixed inset-0 pointer-events-none z-[5] opacity-[0.03]" style="filter: url(#noise)"
      aria-hidden="true" />

    <header
      class="sticky top-0 z-30 backdrop-blur-md bg-stone-50/70 dark:bg-stone-950/70 border-b border-stone-200/50 dark:border-stone-800/50">
      <nav aria-label="Navigation principale"
        class="max-w-6xl mx-auto px-6 md:px-12 py-3 flex items-center justify-between gap-4">
        <a href="#"
          class="text-base font-semibold text-stone-900 dark:text-stone-50 hover:text-terracotta-700 dark:hover:text-terracotta-400 transition-colors">
          Nathalie Gottvalles
        </a>
        <ul class="hidden md:flex items-center gap-6 text-sm text-stone-600 dark:text-stone-400">
          <li v-for="s in sections" :key="s.id">
            <a :href="`#${s.id}`" class="hover:text-terracotta-700 dark:hover:text-terracotta-400 transition-colors">
              {{ s.label }}
            </a>
          </li>
        </ul>
        <ThemeToggle />
      </nav>
    </header>

    <main id="main" class="relative z-[1]">
      <Hero />
      <About />
      <Services />
      <Approaches />
      <Practical />
      <Booking />
      <Contact />
    </main>
    <Footer />
  </div>
</template>
